import styled from '@emotion/styled';
import { Alert, Button, Checkbox, Field, Link, tokens } from '@hotjar/hotsauce';

import { ErrorText } from '@hotjar/webapp/components/ErrorText';

export const Form = styled.form`
  margin: 0 auto;
  max-width: 368px;
  width: 100%;

  label {
    text-transform: none;
  }
`;

export const ColFormWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 0 ${tokens.spacer.x2};
  margin: 0 auto;
`;

export const Title = styled.h2`
  ${tokens.text('header4')};
  margin-bottom: ${tokens.spacer.x6};
`;

export const StyledField = styled(Field)`
  width: 100%;
  margin-bottom: ${tokens.spacer.x3};
  label {
    text-transform: initial;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;
  justify-content: center;
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-bottom: ${({ isInvalid }) => (isInvalid ? '0' : tokens.spacer.x2)};
  text-transform: initial;
`;

export const StyledErrorText = styled(ErrorText)`
  margin-bottom: ${tokens.spacer.x2};
  padding: ${tokens.spacer.x0} 0;
`;

export const TermsOfServiceLink = styled(Link)`
  ${tokens.text('body2')}
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: ${tokens.spacer.x3};
`;

export const ConsentExpandLink = styled(Link)`
  ${tokens.text('body2')};
  margin-left: ${tokens.spacer.x0};
`;

export const ConsentDetailsBlock = styled.div`
  margin: 0 ${tokens.spacer.x2} ${tokens.spacer.x2};
  a {
    text-decoration: underline;
  }
  &:first-child {
    margin-top: ${tokens.spacer.x2};
  }
`;

export const ConsentDetails = styled.div`
  ${tokens.text('caption')}
  background-color: ${tokens.color.bg_info};
  border-radius: ${tokens.radius.m};
  margin: ${tokens.spacer.x1} 0;
  overflow: hidden;
`;

export const ConsentWithdrawLink = styled(Link)`
  font-weight: 600;
`;
